/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancella',
    CONFIRM: 'Conferma',
    SAVE: 'Salvar'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social network',
    USERNAME: 'Nome utente'
  },
  LABEL: {
    CREATE_LINK: 'Aggiungere social network',
    EDIT_LINK: 'Editare social network',
    INACTIVATE_LINK: 'Cancella social network',
    INACTIVATE_LINK_MODAL_TITLE: 'Cancella social network',
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social Network',
    USERNAME: 'Nome utente'
  },
  SENTENCE: {
    ERROR: 'Errore',
    INACTIVATE_LINK_TEXT:
      'Sei sicuro di voler eliminare questo social network?',
    NO_ROWS_LINKS: 'Nessun Social Network'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'Social network eliminato con successo',
    LINKS_DETAILS_SAVED: 'Social network salvato con successo',
    LINKS_DETAILS_UPDATED: 'Social network aggiornato con successo',
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    LINK: 'Link',
    SOCIAL_NETWORK: 'Social network',
    USERNAME: 'Nome utente'
  }
};
